<template>
  <div class="date-range-filter">
    <div class="date-range-filter-label">Período</div>

    <date-picker-range
      :date-selected.sync="date"
      :default-start-date="defaultStartDate"
      :default-end-date="defaultEndDate"
      :clear-button="false"
      calendar-direction="bottom"
      date-filter-alternative
    />
  </div>
</template>

<script>
import moment from 'moment'
import DatePickerRange from '@/components/common/DatePickerRange'

export default {
  name: 'DateRangeFilter',
  components: {
    DatePickerRange
  },
  data() {
    return {
      date: {
        start: new Date(),
        end: new Date(),
      },
      isInitializing: true, // Flag para controlar inicialização
    }
  },
  computed: {
    defaultStartDate() {
      return moment(new Date()).subtract(7, 'days').format('DD/MM/YYYY')
    },
    defaultEndDate() {
      return moment(new Date()).format('DD/MM/YYYY')
    },
  },
  watch: {
    // Watch para mudanças no date (quando usuário interage)
    date: {
      handler(value) {
        // Não executa durante inicialização
        if (this.isInitializing) {
          return
        }
        
        const dateRangeValid = this.validateDateRange(value.start, value.end)
        
        if (dateRangeValid) {
          this.updateRouteQuery(value.start, value.end)
        } else {
          // Se data inválida, volta para datas padrão
          const defaultStart = moment(this.defaultStartDate, 'DD/MM/YYYY').toDate()
          const defaultEnd = moment(this.defaultEndDate, 'DD/MM/YYYY').toDate()
          
          this.isInitializing = true
          this.date = {
            start: defaultStart,
            end: defaultEnd,
          }
          this.$nextTick(() => {
            this.isInitializing = false
          })
          
          this.updateRouteQuery(defaultStart, defaultEnd)
        }
      },
      deep: true
    },
    
    // Watch para mudanças na rota (quando URL muda)
    '$route.query': {
      handler(newQuery, oldQuery) {
        // Só reage se startDate ou endDate mudaram
        if (newQuery.startDate !== oldQuery?.startDate || newQuery.endDate !== oldQuery?.endDate) {
          this.initializeDatesFromQuery()
        }
      },
      deep: true
    }
  },
  created() {
    this.initializeDatesFromQuery()
  },
  methods: {
    initializeDatesFromQuery() {
      let startDate, endDate

      // Se tem query parameters, usa eles
      if (this.$route.query.startDate && this.$route.query.endDate) {
        startDate = moment(this.$route.query.startDate, 'YYYY-MM-DD').toDate()
        endDate = moment(this.$route.query.endDate, 'YYYY-MM-DD').toDate()
      } else {
        // Se não tem query, usa datas padrão
        startDate = moment(new Date()).subtract(7, 'days').toDate()
        endDate = new Date()
      }

      // Atualiza as datas sem trigger do watch
      this.isInitializing = true
      this.date = {
        start: startDate,
        end: endDate,
      }
      
      // Dá um tempo para o Vue atualizar e depois remove a flag
      this.$nextTick(() => {
        this.isInitializing = false
      })
    },
    
    validateDateRange(startDate, endDate) {
      if (!startDate || !endDate) {
        return false
      }
      
      const start = moment(startDate)
      const end = moment(endDate)
      const diffInDays = end.diff(start, 'days')
      
      return diffInDays <= 15 && diffInDays >= 0
    },
    
    updateRouteQuery(startDate, endDate) {
      const newStartDate = moment(startDate).format('YYYY-MM-DD')
      const newEndDate = moment(endDate).format('YYYY-MM-DD')
      
      // Só atualiza a rota se os valores forem diferentes
      if (this.$route.query.startDate !== newStartDate || this.$route.query.endDate !== newEndDate) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            startDate: newStartDate,
            endDate: newEndDate,
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range-filter {
  border: 1px solid #CCCCCC;
  border-radius: 0.25rem;
  height: 40px;
  display: flex;
  align-items: center;
  font-family: 'Exo 2';
  margin-bottom: 1rem;
  padding: 0.25rem;
  width: fit-content;

  &-label {
    font-weight: 500;
    font-size: 13.33px;
    color: #999999;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-right: 1px solid #CCCCCC;
  }

  ::v-deep(.md-input-container) {
    min-height: auto;
    margin: 0;
    padding: 0;
  }
}
</style>
